import { set_token} from "@/router";

export default {

    name: "AICView",

    mounted() {

        this.set_data();
    },

    data() {
        var data = {};

        return data;
    },

    methods: {

        set_data() {
            var token = this.$route.params.token;
            var user_id = this.$route.params.user_id;
            var user_role = this.$route.params.user_role || this.$route.params.role;
            if (token && user_id) {
                set_token(token);
                localStorage.setItem('user_id', user_id);
                localStorage.setItem('user_role', user_role);

                window.location.href = '/home';
            }
        }
    }
}